import L from 'leaflet'

function pad(n) {
  return String(n).padStart(2, '0')
}

export default function registerDrivingDashboard() {
  // Live clock (display only)
  up.compiler('#drClock', (el) => {
    const tick = () => {
      const d = new Date()
      el.textContent = `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    }
    tick()
    const id = setInterval(tick, 1000)
    return () => clearInterval(id)
  })

  // Real-time vehicle position map. The pin data lives in the polled status fragment; every
  // time that fragment is swapped, the markers are rebuilt in place (no map re-init).
  up.compiler('#dashboardMap', (el) => {
    const labels = el.dataset
    const map = L.map(el, { scrollWheelZoom: false })
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map)

    const markers = L.layerGroup().addTo(map)
    let fitted = false
    let openName = null

    const render = (holder) => {
      const pins = holder ? [...holder.querySelectorAll('.dr-pin-data')].map((s) => ({ ...s.dataset })) : []
      markers.clearLayers()
      const bounds = []
      pins.forEach((p) => {
        const lat = parseFloat(p.lat)
        const lng = parseFloat(p.lng)
        if (isNaN(lat) || isNaN(lng)) return
        bounds.push([lat, lng])
        // Pin label shows the crew surname only
        const surname = (p.name || '').split(/[\s　]+/)[0]
        const icon = L.divIcon({
          className: '',
          html: `<div class="dr-pin dr-pin-${p.color}"><span>${surname}</span></div>`,
          iconSize: [44, 44],
          iconAnchor: [22, 44],
          popupAnchor: [0, -44]
        })
        const marker = L.marker([lat, lng], { icon }).bindPopup(`
          <div class="dr-popup">
            <div class="dr-popup-header"><strong>${p.name}</strong>
              <a href="${p.url}" class="btn btn-light btn-sm">${labels.labelReport}</a>
            </div>
            <div>${labels.labelStart}：${p.start}　${labels.labelEnd}：${p.end}</div>
            <div>${labels.labelDistance}：${p.distance}　${labels.labelTime}：${p.time}</div>
          </div>`)
        marker.on('popupopen', () => { openName = p.name })
        marker.on('popupclose', () => { if (openName === p.name) openName = null })
        markers.addLayer(marker)
        // Keep the popup the operator was reading open across refreshes
        if (openName === p.name) marker.openPopup()
      })
      if (!fitted) {
        if (bounds.length) {
          map.fitBounds(bounds, { padding: [40, 40] })
        } else {
          map.setView([34.72383109685586, 135.45281896187524], 11)
        }
        fitted = true
      }
    }

    el.drRender = render
    render(document.getElementById('dashboardMapData'))
    return () => {
      delete el.drRender
      map.remove()
    }
  })

  // Runs on the initial page and on every polled swap of the status fragment
  up.compiler('#dashboardMapData', (holder) => {
    const mapEl = document.getElementById('dashboardMap')
    if (mapEl && typeof mapEl.drRender === 'function') mapEl.drRender(holder)
  })
}
